import React from 'react';
import "../styles/components/subhome.css";
import { Link, useNavigate } from 'react-router-dom';
import { MDBIcon } from 'mdb-react-ui-kit';

const SubHome = ({ mainHeading, listItem }) => {
  const navigate = useNavigate();

  return (
    <div className="sub-home-container">
      <div className="sub-home-bg-image"></div>
      <div className="sub-content">
        {/* Back Button with Icon */}
        <button 
          className="back-button" 
          onClick={() => navigate('/')}
        >
          <MDBIcon fas icon="arrow-left" className="back-icon" />
   
        </button>

        <h1 className="sub-content-heading">{mainHeading}</h1>
        <ol className="sub-content-list">
          <Link to="/"><li className="sub-content-list-item">
          hogar</li></Link>
          <li className="sub-content-list-item sub-content-list-item2">{listItem}</li>
        </ol>
      </div>
    </div>
  );
};

export default SubHome;
